<nav class="navbar navbar-expand-lg bg-light w-100">
  <div class="container-fluid row">
    <!-- Logo Section -->
    <div class="col-lg-3 col-md-3 col-sm-12 d-flex align-items-center">
      <a class="navbar-brand" [routerLink]="['/dashboard']">
        <img style="width:50%;" src="../assets/images/{{logo}}" alt="CPCB Logo">
      </a>
      <button class="navbar-toggler ms-2" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>

    <!-- Title Section -->
    <div class="col-lg-4 col-md-4 d-none d-md-flex align-items-center justify-content-center text-center">
      <div style="color: #31A6F5; font-size: 15px; font-weight: 900; line-height: normal;">
        CENTRAL SOFTWARE OF ONLINE CONTINUOUS EMISSION <br />
        EFFLUENT MONITORING SYSTEM
      </div>
    </div>

    <!-- Nav Links -->
    <div class="col-lg-5 col-md-5 col-sm-12 collapse navbar-collapse justify-content-end" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item" [class.active]="currentRoute === 'dashboard'">
          <a class="nav-link" [routerLink]="['/dashboard']">Home</a>
        </li>
        <li class="nav-item" [class.active]="currentRoute === 'cems'">
          <a class="nav-link" (click)="resetServiceVariable()" [routerLink]="['/cems']">CEMS</a>
        </li>

        <!-- Report Dropdown -->
        <li class="nav-item dropdown"
            [class.active]="isReportActive()">
          <a class="nav-link dropdown-toggle"
             href="#"
             id="reportDropdown"
             role="button"
             data-bs-toggle="dropdown"
             aria-expanded="false">
            Report
          </a>
          <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="reportDropdown">
            <li>
              <a class="dropdown-item"
                 [class.active]="currentRoute === 'close-report'"
                 [routerLink]="['/close-report']">Device Offline Status</a>
            </li>
            <li>
              <a class="dropdown-item"
                 [class.active]="currentRoute === 'sms-report'"
                 [routerLink]="['/sms-report']">Device Alert (SMS) Status</a>
            </li>
            <li>
              <a class="dropdown-item"
                 [class.active]="currentRoute === 'exceedance-report'"
                 [routerLink]="['/exceedance-report']">Device Exceedance Status</a>
            </li>
          </ul>
        </li>

        <li class="nav-item" *ngIf="userLevel == 'admin'"
            [class.active]="currentRoute === 'management'">
          <a class="nav-link" [routerLink]="['/management']">Management</a>
        </li>
        <li class="nav-item" [class.active]="currentRoute === 'slideshow'">
          <a class="nav-link" [routerLink]="['/slideshow']">Slide Show</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="logout()">Logout</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
